import React, { useMemo } from "react";
import { useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import ClientFlowBreadcrumbComponent from "./ClientFlowBreadcrumbComponent";
import { getIcon } from "utils/iconsConfig";
import ClientIconChild from "./ClientIconChild";

function ClientFlowChildHeader({ pageName }) {
  const [breadcrumbs, setBreadcrumbs] = useState([]);
  const navigation = useNavigate();
  const location = useLocation();
  const isCreateCatalog = location?.state?.isCatalog;

  const params = useParams();

  const isExactMatch = location.pathname === `/${pageName}` || location.pathname === `/${pageName.replace(/s$/, "")}`;

  const pathnames = location?.pathname.split("/").filter((x) => x && x !== "client-flow" && x !== params?.clientId);

  const formattedParts = useMemo(() => {
    const name = pathnames?.[0]?.replace(/clients/i, "").trim() || "";

    if (!name) return "";

    let cleaned = name.replace(/^[-_\s]+|[-_\s]+$/g, "");
    const lower = cleaned.toLowerCase();

    const specialCases = {
      wip: "WIP2X",
      "dues-ledger": "Dues & Ledger2X",
      "quotes-orders": "Quotes & Orders2X",
      "npd-orders": "NPD Orders2X",
    };

    if (specialCases[lower]) return specialCases[lower];

    cleaned = cleaned
      .replace(/[-_]+/g, " ")
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ")
      .trim();

    return `${cleaned}2X`;
  }, [location.pathname]);

  const isActive = useMemo(() => {
    if (!pathnames?.length) return "";

    return pathnames.length > 1 ? "" : "Active";
  }, [pathnames]);

  return (
    <div style={{ position: "sticky", zIndex: "1000", top: "70px", background: "black" }}>
      <div style={{ display: "grid", gridAutoFlow: "column", paddingTop: "20px", width: "100%" }}>
        <div className="child-header-sub" style={{ marginLeft: "20px", marginRight: "20px" }}>
          <>
            {!isCreateCatalog && getIcon(formattedParts, isActive)}
            <ClientFlowBreadcrumbComponent />
          </>
        </div>
        <ClientIconChild />
      </div>
    </div>
  );
}

export default ClientFlowChildHeader;
